import {
  Button,
  Modal,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  Card,
  Spin,
  Table,
  Tag
} from "antd";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../config/api";
import { formatPolishCurrency } from "../../helpers/currency";
import { formatPolishDate } from "../../helpers/date";
import AvatarDisplay from "../Dashboard/Account/AvatarDisplay";

const { Title } = Typography;

const getColumns = (t) => [
  {
    title: t('inquiries.table.subject'),
    dataIndex: "name",
    key: "name",
    fixed: "left",
    render: (name, record) => (
      <>
        <Space direction="vertical">
          <u style={{ cursor: "pointer" }}>{name}</u>
          <Space direction="vertical">
            <Tag>{record.account.company_name ? record.account.company_name : t('marketplace.inquiry.privatePerson')}</Tag>
            <Space>
              <AvatarDisplay account={record.account} src={record.account.photo} size={32} /> {record.account.fullname}
            </Space>
          </Space>
        </Space>
      </>
    ),
  },
  {
    title: t('inquiry.form.budget'),
    dataIndex: "budget",
    key: "budget",
    sorter: true,
    render: (budget) => {
      return (<>
        <Tag color="gold-inverse">{formatPolishCurrency(budget)}</Tag>
      </>)

    },
  },
];

export const Inquiries = ({ limit, paginationLimit }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // API endpoint URL
    const apiUrl = `${api.host}/inquiries/active`;

    // Fetch data from the API
    fetch(apiUrl, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const limitedData = limit ? data.slice(0, limit) : data; // Apply limit
        setData(limitedData); // Update the state with the limited data
        setLoading(false); // Set loading to false
      });
  }, [limit]);

  return (
    <Spin spinning={loading}>
      <Row gutter={[24, 24]}>
        {data.map((record, index) => (
          <Col xs={24} md={12} lg={8} key={record.uuid || index}>
            <Card
              style={{
                border: "none",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                borderRadius: "12px",
                cursor: "pointer",
                height: "100%"
              }}
              onClick={() => {
                window.location.href = `/marketplace/inquiry/${record.uuid}`;
              }}
              hoverable
            >
              <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                <AvatarDisplay
                  account={record.account}
                  src={record.account.photo}
                  size={40}
                  style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    marginRight: "12px"
                  }}
                />
                <div>
                  <div style={{ fontWeight: "500" }}>
                    {record.account.company_name || record.account.fullname}
                  </div>

                </div>
              </div>
              <Title level={4} style={{ marginBottom: "8px", fontSize: "16px" }}>
                {record.name}
              </Title>
              <div style={{
                color: "#6c757d",
                marginBottom: "16px",
                fontSize: "14px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden"
              }}>
                {record.message || "No description available"}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ color: "#52c41a", fontWeight: "bold", fontSize: "16px" }}>
                  {formatPolishCurrency(record.budget)}
                </div>
                <div style={{ fontSize: "12px", color: "#6c757d" }}>
                  {record.delivery_days ? `${record.delivery_days} days` : "Flexible"}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      {data.length === 0 && !loading && (
        <div style={{ textAlign: "center", padding: "40px", color: "#6c757d" }}>
          {t('inquiries.noTasks')}
        </div>
      )}
    </Spin>
  );
};
